import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, normalizeLanguage } from "../../i18n";

// Languages offered in the dropdown for now, in this order. All 51 languages are
// still translated in src/i18n/locales; add a code here to make it selectable.
const VISIBLE_CODES = ["en", "fr", "es", "de"];
const VISIBLE_LANGUAGES = VISIBLE_CODES.map((code) =>
  LANGUAGES.find((l) => l.code === code)
).filter(Boolean);

const LanguageSwitcher = ({ className = "", style = {} }) => {
  const { i18n, t } = useTranslation();
  const current = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
  const isVisible = VISIBLE_CODES.includes(current);

  // Someone who picked a language that's no longer offered (e.g. Hindi)
  // goes back to English, so the dropdown always matches the page.
  useEffect(() => {
    if (!isVisible) i18n.changeLanguage("en");
  }, [isVisible, i18n]);

  return (
    <select
      aria-label={t("common.language")}
      className={`form-select form-select-sm w-auto ${className}`}
      style={{ cursor: "pointer", maxWidth: 170, ...style }}
      value={isVisible ? current : "en"}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
    >
      {VISIBLE_LANGUAGES.map((l) => (
        <option key={l.code} value={l.code} title={l.english}>
          {l.label}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
